// import { inject } from '@angular/core';
// import { CanActivateFn, Router } from '@angular/router';
// import { AuthService } from './auth.service';
// export const AuthGuard: CanActivateFn = () => {
//   const auth = inject(AuthService);
//   const router = inject(Router);

//   if (auth.isLoggedIn()) {
//     return true;
//   } else {
//     router.navigate(['signin']);
//     return false;
//   }
// };
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';

export function isTokenValid(token: string | null): boolean {
  if (!token) {
    return false;
  }
  try {
    const helper = new JwtHelperService();
    return !helper.isTokenExpired(token);
  } catch {
    return false;
  }
}

export const AuthGuard: CanActivateFn = () => {
  const router = inject(Router);

  let token: string | null = null;
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      token = localStorage.getItem('token');
    } catch {
      token = null;
    }
  }

  if (!isTokenValid(token)) {
    handleSessionExpired(router);
    return false;
  }

  return true;
};

export const NoAuthGuard: CanActivateFn = () => {
  const router = inject(Router);

  let token: string | null = null;
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      token = localStorage.getItem('token');
    } catch {
      token = null;
    }
  }

  if (isTokenValid(token)) {
    router.navigate(['/gmex/dashboard'], { replaceUrl: true });
    return false;
  }

  return true;
};

function handleSessionExpired(router: Router): void {
  try {
    if (typeof window !== 'undefined') {
      localStorage.clear();
      sessionStorage.clear();

      if ('caches' in window) {
        caches.keys().then(keys => keys.forEach(k => caches.delete(k)));
      }

      router.navigate(['/signin']).then(() => {
        window.location.reload();
      });
    }
  } catch (e) {
    console.error('Error during session cleanup:', e);
    if (typeof window !== 'undefined') {
      window.location.href = '/signin';
    }
  }
}